import { IWebGetFolderOffersByRealtyOfferIdResponse } from '../../repositories/favorites/v1/web-get-folder-offers-by-realty-offer-id';
import { ITypedReduxAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux';

export enum EOffersByRealtyOfferIdActionTypes {
  Set = 'OFFERS_BY_REALTY_OFFER_ID :: SET',
  SetLoading = 'OFFERS_BY_REALTY_OFFER_ID :: SET_LOADING',
  SetFailed = 'OFFERS_BY_REALTY_OFFER_ID :: SET_FAILED',
  SetNote = 'OFFERS_BY_REALTY_OFFER_ID :: SET_NOTE',
  SetNoteLoading = 'OFFERS_BY_REALTY_OFFER_ID :: SET_NOTE_LOADING',
  SetNoteFailed = 'OFFERS_BY_REALTY_OFFER_ID :: SET_NOTE_FAILED',
}

export interface ISetNotePayload {
  realtyOfferId: number;
  comment: string;
}

export type TOffersByRealtyOfferIdActions =
  | ITypedReduxAction<EOffersByRealtyOfferIdActionTypes.Set, IWebGetFolderOffersByRealtyOfferIdResponse>
  | ITypedReduxAction<EOffersByRealtyOfferIdActionTypes.SetLoading, void>
  | ITypedReduxAction<EOffersByRealtyOfferIdActionTypes.SetFailed, void>
  | ITypedReduxAction<EOffersByRealtyOfferIdActionTypes.SetNote, ISetNotePayload>
  | ITypedReduxAction<EOffersByRealtyOfferIdActionTypes.SetNoteLoading, void>
  | ITypedReduxAction<EOffersByRealtyOfferIdActionTypes.SetNoteFailed, void>;

export const setOffersByRealtyOfferId: (
  payload: IWebGetFolderOffersByRealtyOfferIdResponse,
) => TOffersByRealtyOfferIdActions = actionGenerator<
  EOffersByRealtyOfferIdActionTypes.Set,
  IWebGetFolderOffersByRealtyOfferIdResponse
>(EOffersByRealtyOfferIdActionTypes.Set);

export const setOffersByRealtyOfferIdLoading: () => TOffersByRealtyOfferIdActions =
  actionGenerator<EOffersByRealtyOfferIdActionTypes.SetLoading>(EOffersByRealtyOfferIdActionTypes.SetLoading);

export const setOffersByRealtyOfferIdFailed: () => TOffersByRealtyOfferIdActions =
  actionGenerator<EOffersByRealtyOfferIdActionTypes.SetFailed>(EOffersByRealtyOfferIdActionTypes.SetFailed);

export const setOfferNote: (payload: ISetNotePayload) => TOffersByRealtyOfferIdActions = actionGenerator<
  EOffersByRealtyOfferIdActionTypes.SetNote,
  ISetNotePayload
>(EOffersByRealtyOfferIdActionTypes.SetNote);

export const setOfferNoteLoading: () => TOffersByRealtyOfferIdActions =
  actionGenerator<EOffersByRealtyOfferIdActionTypes.SetNoteLoading>(EOffersByRealtyOfferIdActionTypes.SetNoteLoading);

export const setOfferNoteFailed: () => TOffersByRealtyOfferIdActions =
  actionGenerator<EOffersByRealtyOfferIdActionTypes.SetNoteFailed>(EOffersByRealtyOfferIdActionTypes.SetNoteFailed);
